// AUTO-GENERATED FILE. DO NOT EDIT MANUALLY.
// Regenerated on every build by scripts/generate-version.js
export const BUILD_VERSION = "1777980787928";
export const BUILT_AT = "2026-05-05T11:33:07.929Z";
